export default __webpack_public_path__ + "static/media/referrers-icon.485371ee.svg";